<template>
  <div>
    
  </div>
</template>
<script>
export default {
  name: 'HelloWorld',
  data () {
    return {

    }
  },
  mounted(){
    if(!window.navigator) {  
      console.log('app')
    }else{
      if(/Mobile|Android|webOS|iPhone|iPad|Phone/i.test(navigator.userAgent)){
        console.log("移动")
      }
      else{
        console.log('pc')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box{
  background: tan;
  .all{
    width: 100px;
    height: 50px;
    background: red
  }
}
</style>




// WEBPACK FOOTER //
// src/components/HelloWorld.vue